import Loader from '@atoms/Atom/Loader';
import { useShallow } from 'zustand/react/shallow';
import { useLoadingStore } from '@store/loadingStore';

export const useLoading = () =>
  useLoadingStore(useShallow((s) => ({ isLoading: s.isLoading, setIsLoading: s.setIsLoading })));

export const BaseLoader = () => {
  const isLoading = useLoadingStore((s) => s.isLoading);
  if (!isLoading) return null;

  return (
    <Loader
      backgroundColorWrapper={'bg-content2'}
      className="fixed w-full h-full z-[10000]"
    />
  );
};
